module.exports = __webpack_public_path__ + "img/129-Gris Quartz SFTN Mat - Olive.jpg";